<template>
  <div class="flex flex-col sm:flex-row gap-3 mb-6 items-stretch sm:items-center justify-between">
    <!-- Buscador Principal -->
    <div class="relative flex-1">
      <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
        <i class="fa fa-search text-sm" />
      </div>
      <input 
        :value="search"
        type="text"
        class="block w-full pl-10 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-all shadow-sm text-sm" 
        placeholder="Buscar ventas por # de orden, cliente o estado..." 
        @input="$emit('update:search', $event.target.value)"
      />
      <button 
        v-if="search" 
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
        @click="$emit('update:search', '')"
      >
        <i class="fa fa-times-circle text-sm" />
      </button>
    </div>

    <!-- Filtro de Estado -->
    <div class="flex items-center gap-2">
      <div class="relative w-full sm:w-auto">
        <select 
          :value="state || ''"
          class="w-full sm:w-auto pl-4 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg text-gray-700 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 shadow-sm cursor-pointer hover:border-gray-300 transition-colors appearance-none font-medium"
          @change="$emit('update:state', $event.target.value ? $event.target.value : null)"
        >
          <option value="">Todos los estados</option>
          <option v-for="s in states" :key="s.key" :value="s.key">
            {{ s.name }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center px-2.5 pointer-events-none text-gray-400">
          <i class="fa fa-chevron-down text-xs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFilters',

  props: {
    search: {
      type: String,
      default: '',
    },
    state: {
      type: [String, null],
      default: null,
    },
    states: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['update:search', 'update:state', 'reset'],
}
</script>
